export const MEMBER_INTERESTS = [
  "Conservation & Biodiversity", "Wildlife & Nature", "Responsible Tourism", "Adventure & Outdoor",
  "Sports & Youth Development", "Leadership & Team Building", "First Aid, CPR & Rescue",
  "Environmental Education", "Community Development", "Livelihoods & Entrepreneurship",
  "Sustainable Agriculture", "Water, Climate & Disaster Resilience", "Waste & Circular Economy",
  "Digital, Technology & AI", "Research & Field Science", "Photography, Film & Storytelling",
  "Health, Hygiene & Community Wellbeing",
];

export const INTENT_OPTIONS = [
  { value: "TRAINING", label: "Training" },
  { value: "VOLUNTEER", label: "Volunteer" },
  { value: "BOTH", label: "Training + Volunteer" },
];

export const INTENT_LABEL = { TRAINING: "Training", VOLUNTEER: "Volunteer", BOTH: "Training + Volunteer" };

export const MEMBERSHIP_STATUS_LABEL = {
  created: "Payment Pending", active: "Active", failed: "Payment Failed",
  cancelled: "Cancelled", expired: "Expired", refunded: "Refunded",
};

export function fmtINR(n) {
  return `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
